import { BookingResponse, NewBookingData, UpdateBookingData } from '../../types/Booking';
import fetchHandler from './Handler';

export const createBooking = async (bookingData: NewBookingData): Promise<BookingResponse> => {
	// const response = await fetch(API_BASE_URL, {
	// 	method: 'POST',
	// 	headers: {
	// 		'Content-Type': 'application/json',
	// 	},
	// 	body: JSON.stringify(bookingData),
	// });
	const response = await fetchHandler({
		method: 'POST',
		endpoint: `booking`,
		data: bookingData,
	});
	return response;
	// return response.json();
};

export const getAllBookings = async (): Promise<BookingResponse> => {
	const response = await fetchHandler({
		method: 'GET',
		endpoint: 'booking',
	});
	return response;
};

export const getBookingById = async (id: string): Promise<BookingResponse> => {
	// const response = await fetch(`${API_BASE_URL}/${id}`, {
	// 	method: 'GET',
	// 	headers: {
	// 		Authorization: `Bearer ${token}`,
	// 		'Content-Type': 'application/json',
	// 	},
	// });
	// return response.json();
	const response = await fetchHandler({
		method: 'GET',
		endpoint: `booking/${id}`,
	});
	return response;
};

export const updateBooking = async (
	id: string,
	updateData: UpdateBookingData
): Promise<BookingResponse> => {
	const response = await fetchHandler({
		method: 'PATCH',
		endpoint: `booking/${id}`,
		data: updateData,
	});
	return response;
};
